import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import React from "react";

export type MapProps = {
  text: string;
};
export default (props: MapProps) => (
  <div className="list-icon-item">
    <Icon icon={IconType.ArrowRight} />

    <span className="link">{props.text}</span>
  </div>
);
